import { useMemo } from 'react'

import { generateUniqueId } from './utilities'

export function useId(idOverride?: string) {
    return useMemo(() => idOverride || generateUniqueId(), [idOverride])
}
